import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { client } from "../lib/api";

export const useVideoSearch = (q: string, offset: number) => {
  return useQuery({
    queryKey: ["search", q],
    queryFn: () =>
      client.videos.getVideosVideoSearch({
        q,
        count: 10,
        offset,
      }),
  });
};

export function useVideoSelector(query: string) {
  const [offset, setOffset] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const { data, isLoading, error } = useVideoSearch(query, offset);

  const results = data?.results ?? [];

  const selectedVideo = useMemo(() => {
    return results[selectedIndex] ?? null;
  }, [results, selectedIndex]);

  return {
    results,
    selectedVideo,

    selectedIndex,
    setSelectedIndex,

    offset,
    setOffset,

    isLoading,
    error,
  };
}
